import styled from "styled-components";
import { CustomExternalLink } from "../common";

export const StyledFooter = styled.div`
  color: ${(props) => props.theme.palette.redesign.black};
  height: 2.5rem;
   ${({ theme }) => theme.breakpoints.up("sm")} {
    height: 4rem;
   }
`;

export const LegalDocuments = styled.div`
  //TODO: add support for poppins
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem 1rem;
  padding: 0.81rem 1rem;
  background-color: ${(props) => props.theme.palette.redesign.black};
  color: ${(props) => props.theme.palette.redesign.white};
  font-size: 0.9375rem;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: end;
    padding: 1.5rem 5rem;
    font-size: 1.125rem;
  }
   ${({ theme }) => theme.breakpoints.up("laptop")} {
    padding: 1.5rem 8rem;
    gap : 2.5rem;
    font-size : 1.3125rem;
   }
`;
export const LegalDocumentLink = styled(CustomExternalLink)`
  color: ${(props) => props.theme.palette.redesign.white};
  opacity: 0.9;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 1;
    color: ${(props) => props.theme.palette.redesign.white};
  }
`;
